/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../types/api";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const setupMunicipalityData = /* GraphQL */ `mutation SetupMunicipalityData(
  $municipalityId: String!
  $services: NicottoServicesInput
) {
  setupMunicipalityData(municipalityId: $municipalityId, services: $services)
}
` as GeneratedMutation<
  APITypes.SetupMunicipalityDataMutationVariables,
  APITypes.SetupMunicipalityDataMutation
>;
export const updateAccount = /* GraphQL */ `mutation UpdateAccount($municipality: MunicipalityInput!, $user: UserInput!) {
  updateAccount(municipality: $municipality, user: $user)
}
` as GeneratedMutation<
  APITypes.UpdateAccountMutationVariables,
  APITypes.UpdateAccountMutation
>;
export const publishConcierge = /* GraphQL */ `mutation PublishConcierge(
  $municipalityId: String!
  $mode: String!
  $categoryId: String
) {
  publishConcierge(
    municipalityId: $municipalityId
    mode: $mode
    categoryId: $categoryId
  )
}
` as GeneratedMutation<
  APITypes.PublishConciergeMutationVariables,
  APITypes.PublishConciergeMutation
>;
export const batchImportConciergeDepartment = /* GraphQL */ `mutation BatchImportConciergeDepartment(
  $municipalityId: String!
  $input: [ConciergeDepartmentInput!]!
) {
  batchImportConciergeDepartment(
    municipalityId: $municipalityId
    input: $input
  ) {
    code
    name
    locations
    tel
    url
    orderSeq
    note
    __typename
  }
}
` as GeneratedMutation<
  APITypes.BatchImportConciergeDepartmentMutationVariables,
  APITypes.BatchImportConciergeDepartmentMutation
>;
export const batchImportConciergeProcess = /* GraphQL */ `mutation BatchImportConciergeProcess(
  $municipalityId: String!
  $input: [ConciergeProcessInput!]!
) {
  batchImportConciergeProcess(municipalityId: $municipalityId, input: $input) {
    processId
    name
    department {
      code
      name
      locations
      tel
      url
      orderSeq
      note
      __typename
    }
    link {
      name
      url
      __typename
    }
    refId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.BatchImportConciergeProcessMutationVariables,
  APITypes.BatchImportConciergeProcessMutation
>;
export const batchImportConciergeQuestion = /* GraphQL */ `mutation BatchImportConciergeQuestion($input: [ConciergeQuestionInput!]!) {
  batchImportConciergeQuestion(input: $input) {
    id
    sortKey
    name
    question
    supplement
    skip {
      yes
      no
      __typename
    }
    processes {
      condition
      processId
      name
      belongings
      additionalContacts
      supplement
      note
      __typename
    }
    type
    orderBy
    __typename
  }
}
` as GeneratedMutation<
  APITypes.BatchImportConciergeQuestionMutationVariables,
  APITypes.BatchImportConciergeQuestionMutation
>;
export const createConciergeProcess = /* GraphQL */ `mutation CreateConciergeProcess(
  $municipalityId: String!
  $input: ConciergeProcessInput!
) {
  createConciergeProcess(municipalityId: $municipalityId, input: $input) {
    processId
    name
    department {
      code
      name
      locations
      tel
      url
      orderSeq
      note
      __typename
    }
    link {
      name
      url
      __typename
    }
    refId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateConciergeProcessMutationVariables,
  APITypes.CreateConciergeProcessMutation
>;
export const updateConciergeProcess = /* GraphQL */ `mutation UpdateConciergeProcess(
  $municipalityId: String!
  $input: ConciergeProcessInput!
) {
  updateConciergeProcess(municipalityId: $municipalityId, input: $input) {
    processId
    name
    department {
      code
      name
      locations
      tel
      url
      orderSeq
      note
      __typename
    }
    link {
      name
      url
      __typename
    }
    refId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateConciergeProcessMutationVariables,
  APITypes.UpdateConciergeProcessMutation
>;
export const createConciergeDepartment = /* GraphQL */ `mutation CreateConciergeDepartment(
  $municipalityId: String!
  $input: ConciergeDepartmentInput!
) {
  createConciergeDepartment(municipalityId: $municipalityId, input: $input) {
    code
    name
    locations
    tel
    url
    orderSeq
    note
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateConciergeDepartmentMutationVariables,
  APITypes.CreateConciergeDepartmentMutation
>;
export const putConciergeDepartment = /* GraphQL */ `mutation PutConciergeDepartment(
  $municipalityId: String!
  $input: ConciergeDepartmentInput!
) {
  putConciergeDepartment(municipalityId: $municipalityId, input: $input) {
    code
    name
    locations
    tel
    url
    orderSeq
    note
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PutConciergeDepartmentMutationVariables,
  APITypes.PutConciergeDepartmentMutation
>;
export const createConciergeCategory = /* GraphQL */ `mutation CreateConciergeCategory(
  $municipalityId: String!
  $input: ConciergeCategoryInput!
) {
  createConciergeCategory(municipalityId: $municipalityId, input: $input) {
    categoryId
    pageId
    name
    description
    lead
    iconPath
    links {
      name
      url
      __typename
    }
    orderBy
    refId
    displayCommonBelongings
    belongings
    startButtonName
    publishMode
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateConciergeCategoryMutationVariables,
  APITypes.CreateConciergeCategoryMutation
>;
export const updateConciergeCategory = /* GraphQL */ `mutation UpdateConciergeCategory(
  $municipalityId: String!
  $input: ConciergeCategoryInput!
) {
  updateConciergeCategory(municipalityId: $municipalityId, input: $input) {
    categoryId
    pageId
    name
    description
    lead
    iconPath
    links {
      name
      url
      __typename
    }
    orderBy
    refId
    displayCommonBelongings
    belongings
    startButtonName
    publishMode
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateConciergeCategoryMutationVariables,
  APITypes.UpdateConciergeCategoryMutation
>;
export const deleteConciergeCategory = /* GraphQL */ `mutation DeleteConciergeCategory(
  $municipalityId: String!
  $input: ConciergeCategoryInput!
) {
  deleteConciergeCategory(municipalityId: $municipalityId, input: $input)
}
` as GeneratedMutation<
  APITypes.DeleteConciergeCategoryMutationVariables,
  APITypes.DeleteConciergeCategoryMutation
>;
export const updateSortConciergeList = /* GraphQL */ `mutation UpdateSortConciergeList(
  $municipalityId: String!
  $input: [NicottoOrderListInput]!
) {
  updateSortConciergeList(municipalityId: $municipalityId, input: $input) {
    sortKey
    orderBy
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSortConciergeListMutationVariables,
  APITypes.UpdateSortConciergeListMutation
>;
export const createMunicipality = /* GraphQL */ `mutation CreateMunicipality(
  $input: CreateMunicipalityInput!
  $condition: ModelMunicipalityConditionInput
) {
  createMunicipality(input: $input, condition: $condition) {
    id
    sortKey
    name
    type
    orderBy
    refId
    services {
      concierge
      __typename
    }
    locations
    tel
    prefecture
    path
    corporateNumber
    code
    department
    link {
      name
      url
      __typename
    }
    skip {
      yes
      no
      __typename
    }
    supplement
    description
    question
    iconPath
    pageId
    contact
    publishMode
    orderSeq
    url
    note
    processes {
      condition
      processId
      name
      belongings
      additionalContacts
      supplement
      note
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMunicipalityMutationVariables,
  APITypes.CreateMunicipalityMutation
>;
export const updateMunicipality = /* GraphQL */ `mutation UpdateMunicipality(
  $input: UpdateMunicipalityInput!
  $condition: ModelMunicipalityConditionInput
) {
  updateMunicipality(input: $input, condition: $condition) {
    id
    sortKey
    name
    type
    orderBy
    refId
    services {
      concierge
      __typename
    }
    locations
    tel
    prefecture
    path
    corporateNumber
    code
    department
    link {
      name
      url
      __typename
    }
    skip {
      yes
      no
      __typename
    }
    supplement
    description
    question
    iconPath
    pageId
    contact
    publishMode
    orderSeq
    url
    note
    processes {
      condition
      processId
      name
      belongings
      additionalContacts
      supplement
      note
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMunicipalityMutationVariables,
  APITypes.UpdateMunicipalityMutation
>;
export const deleteMunicipality = /* GraphQL */ `mutation DeleteMunicipality(
  $input: DeleteMunicipalityInput!
  $condition: ModelMunicipalityConditionInput
) {
  deleteMunicipality(input: $input, condition: $condition) {
    id
    sortKey
    name
    type
    orderBy
    refId
    services {
      concierge
      __typename
    }
    locations
    tel
    prefecture
    path
    corporateNumber
    code
    department
    link {
      name
      url
      __typename
    }
    skip {
      yes
      no
      __typename
    }
    supplement
    description
    question
    iconPath
    pageId
    contact
    publishMode
    orderSeq
    url
    note
    processes {
      condition
      processId
      name
      belongings
      additionalContacts
      supplement
      note
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMunicipalityMutationVariables,
  APITypes.DeleteMunicipalityMutation
>;
